<template>
  <div class="apply-detail-table" ref="parent">
    <apply-detail-cell
      ref="cell"
      v-for="item in data"
      :key="item.bizOrderNo"
      :data="item"
      @change="handleCellChange"
      @calculate="handleCellCalculate"
    ></apply-detail-cell>
    <div
      class="footer"
      ref="footer"
      :class="{ 'is--fixed': footerFixed }"
      :style="{ left: `${fixedLeft}px`, width: `${fixedWidth}px` }"
    >
      <div>
        <div class="flex flex-sb">
          <el-checkbox :value="checkedAll" @change="handleCheckeAll">全选</el-checkbox>
          <div class="f-14 c-3 f-b-500">
            <span class="m-l20"
              >待结算总计：
              <span class="f-20 c-hover">{{ totalQuantity ? totalQuantity : '--' }}</span
              >件， <span class="f-20 c-hover">{{ totalWeight ? totalWeight : '--' }}</span
              >吨
            </span>
            <span class="m-l20"
              >结算金额：¥
              <span class="f-20 c-hover">{{ totalAmount | formatTotalAmount }}</span>
            </span>
          </div>
        </div>
        <div class="flex flex-sb m-t8">
          <div class="f-14 flex flex-ac">
            备注：<el-input
              v-model.trim="remark"
              type="textarea"
              :rows="1"
              style="width:300px;"
              resize="none"
              size="mini"
              placeholder="请输入备注"
              :maxlength="200"
              show-word-limit
            ></el-input>
          </div>
          <el-button size="small" type="primary" @click="createOrder">生成结算单</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApplyDetailCell from './apply-detail-cell'
import NP from 'number-precision'
import { formatMoneyCent, formatPermil } from '@/common/filters'
import { calculateWithUnit } from '@/common/utils/calculate.js'

export default {
  name: 'ApplyDetailList',
  components: { ApplyDetailCell },
  props: {
    data: Array
  },
  watch: {
    data() {
      this.calculateTotal()
      this.$nextTick(() => {
        this.update()
      })
    }
  },
  data() {
    return {
      checkedAll: true,
      totalQuantity: 0,
      totalWeight: 0,
      totalAmount: 0,
      remark: '',
      scrollCache: { offsetTopHeight: 0 },
      footerFixed: false,
      fixedLeft: 0,
      fixedWidth: 0
    }
  },
  filters: {
    formatTotalAmount(amount) {
      if (typeof amount === 'string') {
        amount = parseFloat(amount)
        if (isNaN(amount)) {
          return '--'
        }
      } else if (typeof amount !== 'number') {
        return '--'
      }
      let parts = amount.toString().split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return parts.join('.')
    }
  },
  mounted() {
    this.addEventListener()
  },
  beforeDestroy() {
    this.removeEventListener()
  },
  methods: {
    addEventListener() {
      const scrollConstainer = document.querySelector('main.el-main.container')
      const appMain = document.querySelector('.app-main')
      this.scrollCache.scrollConstainer = scrollConstainer
      this.scrollCache.appMain = appMain
      if (scrollConstainer && appMain) {
        //计算header高度
        const header = document.querySelector('header.el-header.hreader')
        if (header) {
          this.scrollCache.offsetTopHeight += header.offsetHeight
        }
        //计算tagviews高度
        const tagviews = document.querySelector('.fixed-header')
        if (tagviews) {
          this.scrollCache.offsetTopHeight += tagviews.offsetHeight
        }
        //计算footer的高度
        this.scrollCache.footerHeight =
          this.$refs.footer.offsetHeight +
          Number.parseInt(window.getComputedStyle(this.$refs.footer).marginTop)

        this.fixedWidth = this.$refs.parent.offsetWidth
        scrollConstainer.addEventListener('scroll', this.update)
        window.addEventListener('resize', this.resizeHandle)
        window.addEventListener('scroll', this.horizontalScrollHandle)
      }
    },
    removeEventListener() {
      const { scrollConstainer, appMain } = this.scrollCache
      if (scrollConstainer && appMain) {
        scrollConstainer.removeEventListener('scroll', this.update)
        window.removeEventListener('resize', this.resizeHandle)
        window.removeEventListener('scroll', this.horizontalScrollHandle)
      }
    },
    update() {
      const { scrollConstainer, appMain, offsetTopHeight, footerHeight } = this.scrollCache
      const screenHeight = window.innerHeight - offsetTopHeight
      let appMainHeight = appMain.offsetHeight
      if (this.footerFixed) {
        appMainHeight += footerHeight
      }
      if (screenHeight + scrollConstainer.scrollTop < appMainHeight) {
        this.footerFixed = true
        if (this.fixedLeft === 0) {
          this.fixedLeft = this.$refs.parent.getBoundingClientRect().left
        }
      } else {
        this.footerFixed = false
        this.fixedLeft = 0
      }
    },
    resizeHandle() {
      setTimeout(() => {
        this.fixedWidth = this.$refs.parent.offsetWidth
        this.fixedLeft = this.$refs.parent.getBoundingClientRect().left
      }, 250)
    },
    horizontalScrollHandle() {
      this.fixedLeft = this.$refs.parent.getBoundingClientRect().left
    },
    handleCellChange() {
      const obj = this.data.find(ele => !ele.$checked)
      this.checkedAll = obj ? false : true
      this.calculateTotal()
    },
    handleCellCalculate() {
      this.calculateTotal()
    },
    handleCheckeAll(val) {
      this.checkedAll = val
      this.data.forEach(p => {
        p.$checked = val
        p.list.forEach(c => {
          c.$checked = val
        })
      })
      this.$refs.cell.forEach(val => {
        val.calculateTotal()
      })
      this.calculateTotal()
    },
    calculateTotal() {
      let totalQuantity = 0
      let totalWeight = 0
      let totalAmount = 0
      this.data.forEach(p => {
        totalQuantity = NP.plus(totalQuantity, p.$totalQuantity)
        totalWeight = NP.plus(totalWeight, NP.times(p.$totalWeight, 1000000))
        totalAmount = NP.plus(totalAmount, p.$totalAmount)
      })
      this.totalQuantity = totalQuantity
      this.totalWeight = NP.divide(totalWeight, 1000000)
      this.totalAmount = totalAmount
      this.$emit('calculate', totalAmount)
    },
    async createOrder() {
      let totalArray = []
      this.data.forEach(ele => {
        totalArray = totalArray.concat(ele.list.filter(child => child.$checked))
      })
      if (totalArray.length > 0) {
        if (this.totalAmount === 0) {
          this.$message.error('结算总金额不能为0')
          return
        }
        const settleOrderItemsCreateRequestList = []
        totalArray.forEach(ele => {
          let settleApplyItemId = ele.settleApplyItemId
          let settlePerAmount = ele.$settlePerAmount
            .replace('¥', '')
            .replace(`/${ele.chargeUnit}`, '')
          settlePerAmount = NP.times(settlePerAmount, 100)
          let settleQuantity = Number(ele.$settleQuantity.replace('件', ''))
          let settleWeight = ele.$settleWeight.replace('吨', '')
          settleWeight = NP.times(settleWeight, 10000)
          let settleAmount = ele.$settleAmount.replace('¥', '')
          settleAmount = NP.times(settleAmount, 100)
          settleOrderItemsCreateRequestList.push({
            settleApplyItemId,
            settlePerAmount,
            settleQuantity,
            settleWeight,
            settleAmount
          })
        })
        const request = { remark: this.remark, settleOrderItemsCreateRequestList }
        const { success, data } = await this.$post('settle.seller.createSettleOrder', { request })
        if (success && data) {
          const { settleOrderId, settleOrderNo } = data[0]
          this.$emit('refresh')
          this.createSuccessTips(settleOrderId)
        }
      } else {
        this.$message.error('请选择提货单')
      }
    },
    createSuccessTips(settleOrderId) {
      this.$confirm('结算单生成成功！', '提示', {
        confirmButtonText: '查看结算详情',
        cancelButtonText: '继续生成结算',
        type: 'success',
        center: true
      })
        .then(() => {
          this.$router.push({
            name: 'SettlementDetail',
            params: { id: settleOrderId }
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less">
.apply-detail-table {
  .el-checkbox {
    width: 16px;
    height: 16px;
    min-width: 0;
  }
}
</style>

<style lang="scss" scoped>
.apply-detail-table {
  .is--fixed {
    position: fixed;
    bottom: 0;
  }
  .footer {
    margin-top: 20px;
    background: #ffffff;
    z-index: 10;
    height: 80px;
    padding: 0 20px 0 10px;
    border: 1px solid #f0f0f0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
